import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";
import { getTouchbackYardline } from "../../utils/context-utils";

export default class FairCatchTouchback extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { gameConfig, homeTeamHasPossession, fieldPosition } =
            gameContext;
        const { autoFairCatchTb } = gameConfig.general;
        const tbSpot = getTouchbackYardline(
            true,
            homeTeamHasPossession,
            gameConfig
        );

        return (
            play.getPreviousFragment(fragment).associatedState ===
                FootballState.KickOff &&
            autoFairCatchTb &&
            (homeTeamHasPossession
                ? fieldPosition < tbSpot
                : fieldPosition > tbSpot)
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { homeTeamHasPossession, gameConfig } = gameContext;
        const { fieldLength } = gameConfig.general;
        const { touchbackYardline } = gameConfig.spots;
        const tbSpot = homeTeamHasPossession
            ? touchbackYardline
            : fieldLength - touchbackYardline;
        gameContext.setFieldPosition(tbSpot);
    }
}
